import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import MainPageBanner from '../../components/MainPageBanner';
import bemClassName from '../../utils/bem';
import Button from '../../UI/Button';
import Loading from '../../UI/Loading';
import getAuthUrl from '../../utils/getAuthUrl';

import './index.scss';
import PrivateData from '../../API/PrivateData';

const orderPage = bemClassName('order-page');

const Order = () => {
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const [order, setOrder] = useState<any>();
  const [orderError, setOrderError] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);

  const handleRedirect = () => {
    if (order) {
      window.location.href = `/catalog/${order.deal.city_name}/${order.deal.product_id}/`;
    }
  };

  const handleLogin = () => {
    getAuthUrl()
      .then((url) => {
        if (url && url !== undefined) {
          window.location.href = url;
        }
      })
      .catch((error) => {
        console.log(error);
        window.location.href = '/';
      });
  };

  useEffect(() => {
    if (order && order.status) {
      if (order.status === 'succeeded') {
        handleRedirect();
      }
      if (order.status === 'canceled') {
        setOrderError('Платеж отменен');
      }
      setIsLoading(false);
    }
  }, [order]);

  useEffect(() => {
    setIsLoading(true);
    if (isLogin !== null && isLogin) {
      const getQueryParam = (name: string): string | null => {
        return new URLSearchParams(window.location.search).get(name);
      };
      const orderId = getQueryParam('id');
      if (orderId) {
        try {
          PrivateData.getOrder(orderId)
            .then((resp) => {
              setOrder(resp);
            })
            .catch((error) => {
              setOrderError(String(error));
              setIsLoading(false);
            });
        } catch (e) {
          setOrderError('Платеж не найден');
          setIsLoading(false);
        }
      }
    } else {
      setOrderError('Необходимо авторизоваться');
      setIsLoading(false);
    }
  }, [isLogin]);

  return (
    <>
      <MainPageBanner>
        {isLoading ? (
          <Loading externalClassName={orderPage('loading')} />
        ) : (
          <>
            {order ? (
              <>
                <h3 className={orderPage('title')}>{order.description}</h3>
                <h1 className={orderPage('sub-title')}>Платеж успешно принят</h1>
                <p>
                  В настоящее время идет зачисление платежа. Обычно это занимает всего несколько
                  секунд.
                </p>
                <Button
                  externalClassName={orderPage('button')}
                  text="Перейти к брони"
                  handleExternal={handleRedirect}
                />
              </>
            ) : (
              <>
                <h1 className={orderPage('sub-title')}>{orderError}</h1>
                {!isLogin && (
                  <Button
                    externalClassName={orderPage('button')}
                    text="Войти"
                    handleExternal={handleLogin}
                  />
                )}
              </>
            )}
          </>
        )}
      </MainPageBanner>
    </>
  );
};

export default Order;
